import { commonErrors } from '@utils/error';
import { exists } from '@utils/general';
import { requiredString } from '@utils/validation';
import { z } from 'zod';

export const testContent = {};

export const schema = z.object({
	insuranceProvider: requiredString(commonErrors.selectionRequired).refine((provider) => {
		return exists(provider);
	}, commonErrors.selectionRequired),
});
